import api from "@helpers/api";
import { SHARED_SUB_TASKS_ENDPOINT } from "./config";

export const fetchSharedSubTasks = async (query: any) => {
  const res = await api.get(`${SHARED_SUB_TASKS_ENDPOINT}`, {
    params: query,
  });

  return res;
};
